import { API, Auth } from "aws-amplify";
import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Image,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { globalStyles } from "../styles/globalStyles";
import { Ionicons } from "@expo/vector-icons";
import { UserContext } from "../globalData/UserContext";
import { CommunityContext } from "../globalData/ComunityContext";
import {
  getReviews,
  getUsers,
  listReviews,
  listUsers,
} from "../src/graphql/queries";
import { FlatList, TextInput } from "react-native-gesture-handler";
import SelectCard from "../styles/selectCard";
import {
  createUserCommunities,
  deleteBooks,
  deleteCommunity,
  deleteRequests,
  deleteUserCommunities,
  deleteUsers,
  updateUsers,
} from "../src/graphql/mutations";
import { ComNavContext } from "../globalData/ComNavContext";
import ChooseAvatar from "./components/ChooseAvatar";

export default function CommInfo() {
  const userData = useContext(UserContext);
  const user = userData.user;
  const communityInfo = useContext(CommunityContext);
  const [comUsers, setComUsers] = useState();
  const communityNavigation = useContext(ComNavContext);
  const [text, setText] = useState("");
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    getReviews();
    userData.refreshUser();
  }, []);

  async function getReviews() {
    const allReviews = await API.graphql({ query: listReviews });
    setReviews(allReviews.data.listReviews.items);
  }

  // async function deleteAccount() {
  //   try {
  //     await Auth.deleteUser();
  //     await deleteDynamoData();
  //     await retrieveUsers();
  //   } catch (error) {
  //     console.log("error deleting user, " + error);
  //   }
  // }

  // async function deleteDynamoData() {
  //   const userComs = user.data.getUsers.communities.items;
  //   await Promise.all(
  //     userComs.map((userCom) => {
  //       leaveCommunity(userCom);
  //     })
  //   );
  //   await deleteDynamoUser();
  //   await removeUserRequests();
  //   userData.refreshUser();
  // }

  // async function deleteDynamoUser() {
  //   try {
  //     await API.graphql({
  //       query: deleteUsers,
  //       variables: {
  //         input: {
  //           uId: user.data.getUsers.uId,
  //         },
  //       },
  //     });
  //   } catch (evt) {
  //     console.log(evt);
  //   }
  // }

  async function retrieveUsers() {
    const userComs = communityInfo.currCom.users.items;
    const users = await Promise.all(
      userComs.map(async (user) => {
        return API.graphql({
          query: getUsers,
          variables: { uId: user.usersCommunitiesUId },
        });
      })
    );

    setComUsers(
      users.sort((user1, user2) => {
        return (
          (user1.data.getUsers.ownBooks.items.length -
            user2.data.getUsers.ownBooks.items.length) *
          -1
        );
      })
    );
  }

  async function leaveCommunity(userCom) {
    if (typeof userCom != "undefined") {
      // await removeUserRequests();
      // await updateBookStatus();
      await updateUserComs(userCom);
      await deleteUserBooks(userCom);
    }
    communityInfo.updateCommunity(null);
    await retrieveUsers();
    communityNavigation.communityNav.navigate("Communities");
  }

  // deletes requests across ALL communities --
  // should only delete requests for that single community (when leaving).
  // async function removeUserRequests() {
  //   const userRequests = user.data.getUsers.requests.items;
  //   await Promise.all(
  //     userRequests.map(async (request) => {
  //       try {
  //         await API.graphql({
  //           query: deleteRequests,
  //           variables: {
  //             input: {
  //               id: request.id,
  //             },
  //           },
  //         });
  //       } catch (evt) {
  //         console.log(evt);
  //       }
  //     })
  //   );
  // }

  // queue all the books, filter so only those in the community show up,
  // check the number of requests and its status -- if the status is requested
  // with no requests under it, it must be marked as available.
  // async function updateBookStatus() {}

  async function updateUserComs(deletedUserCom) {
    try {
      await API.graphql({
        query: deleteUserCommunities,
        variables: {
          input: {
            id: deletedUserCom.id,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function deleteUserBooks(userCom) {
    const userBooks = user.data.getUsers.ownBooks.items;
    const userComBooks = userBooks.filter(
      (book) => book.communityBooksCId == userCom.communityUsersCId
    );
    await Promise.all(
      userComBooks.map(async (book) => {
        await removeBooks(book);
        await removeBookRequests(book);
      })
    );
  }

  async function removeBooks(book) {
    try {
      await API.graphql({
        query: deleteBooks,
        variables: {
          input: {
            bookId: book.bookId,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function removeBookRequests(book) {
    if (typeof book.requests !== "undefined") {
      const bookrequests = book.requests.items;
      let deletedRequests;
      if (bookrequests != null) {
        deletedRequests = bookrequests.filter((request) => {
          request.usersRequestsUId == user.data.getUsers.uId;
        });

        await Promise.all(
          deletedRequests.map(async (request) => {
            try {
              await API.graphql({
                query: deleteRequests,
                variables: {
                  input: {
                    id: request.id,
                  },
                },
              });
            } catch (evt) {
              console.log(evt);
            }
          })
        );
      }
    }
  }

  useEffect(() => {
    retrieveUsers();
  }, []);

  async function submitHandler() {
    const users = await API.graphql({ query: listUsers });
    const allUsers = users.data.listUsers.items;
    let validAnswer = false;
    let validUser = {};
    allUsers.map((allUser) => {
      if (
        text.toLowerCase() == allUser.userName.toLowerCase() &&
        !allUser.student
      ) {
        validAnswer = true;
        validUser = allUser;
      }
    });
    comUsers.map((comUser) => {
      if (text.toLowerCase() == comUser.data.getUsers.userName.toLowerCase()) {
        validAnswer = false;
      }
    });
    if (validAnswer) {
      await addUserToCommunity(validUser);
      Alert.alert(text + " has been added to the community!");
      if (Platform.OS == web)
        window.confirm(text + " has been added to the community!");
      setText("");
      userData.refreshUser();
      await retrieveUsers();
    } else
      Alert.alert(
        "Invalid User: this user does not exist or already is in the community."
      );
    if (Platform.OS == "web")
      window.confirm(
        "Invalid User: this user does not exist or already is in the community."
      );
  }

  async function addUserToCommunity(user) {
    try {
      await API.graphql({
        query: createUserCommunities,
        variables: {
          input: {
            communityUsersCId: communityInfo.currCom.cId,
            usersCommunitiesUId: user.uId,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function deleteCom() {
    const users = communityInfo.currCom.users.items;
    if (users.length <= 1) {
      try {
        await API.graphql({
          query: deleteCommunity,
          variables: {
            input: {
              cId: communityInfo.currCom.cId,
            },
          },
        });
      } catch (evt) {
        console.log(evt);
      }
      communityInfo.updateCommunity(null);
    }
  }

  function getUsername(item) {
    if (item.data.getUsers != null && item.data.getUsers.userName != null)
      if (item.data.getUsers.userName.length > 8)
        return item.data.getUsers.userName.substring(0, 8);
      else return item.data.getUsers.userName;
    return "";
  }
  return (
    <View
      style={{
        ...globalStyles.container,
        padding: 0,
        backgroundColor: "#E2CFC2",
      }}
    >
      <TextInput
        style={styles.input}
        placeholderTextColor="#A48578"
        placeholder="Add a User"
        onChangeText={(text) => setText(text)}
      />
      {text != "" && (
        <Pressable
          style={styles.submitButton}
          onPress={async () => {
            await submitHandler();
          }}
        >
          <Text style={styles.buttonText}>Submit</Text>
        </Pressable>
      )}
      <Text style={styles.userTitleText}>
        {communityInfo.currCom.cName.trim() + " users"}
      </Text>
      <View style={styles.statStyle}>
        <Text style={{ fontFamily: "quicksand-bold", color: "#e2cfc2" }}>
          Shares
        </Text>
        <Text
          style={{
            fontFamily: "quicksand-bold",
            color: "#e2cfc2",
            marginLeft: Platform.OS == "web" ? 60 : 10,
          }}
        >
          Borrows
        </Text>
        <Text
          style={{
            fontFamily: "quicksand-bold",
            color: "#e2cfc2",
            marginLeft: Platform.OS == "web" ? 60 : 10,
            marginRight: 3,
          }}
        >
          Recommends
        </Text>
      </View>
      <FlatList
        style={{ flex: 4 }}
        data={comUsers}
        numColumns={1}
        renderItem={({ item }) => (
          <View style={styles.bar}>
            {item.data.getUsers.profilePicture == null ? (
              <Ionicons
                name="md-person-circle-outline"
                color="#A48578"
                size={60}
                style={{ marginLeft: 5 }}
              />
            ) : (
              <Image
                source={{
                  uri: item.data.getUsers.profilePicture,
                  width: 50,
                  height: 50,
                }}
                style={{ borderRadius: 30, marginLeft: 10 }}
              />
            )}
            <Text style={styles.usernames}> {getUsername(item)}</Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                justifyContent: "flex-end",
              }}
            >
              <Ionicons
                name="paper-plane"
                size={25}
                color="#ae56b0"
                style={{
                  marginLeft: Platform.OS == "web" ? 90 : 30,
                  marginRight: 5,
                }}
              />
              <Text
                style={{
                  fontFamily: "quicksand-bold",
                  color: "#6e4732",
                  marginRight: 10,
                }}
              >
                {item.data.getUsers.ownBooks.items.length}
              </Text>
              <Ionicons
                name="book"
                size={25}
                color="#58bf7d"
                style={{
                  marginLeft: Platform.OS == "web" ? 90 : 30,
                  marginRight: 5,
                }}
              />
              <Text
                style={{
                  fontFamily: "quicksand-bold",
                  color: "#6e4732",
                  marginRight: 10,
                }}
              >
                {item.data.getUsers.borrowerTransactions.items.length}
              </Text>
              <Ionicons
                name="thumbs-up"
                size={25}
                color="#4298c9"
                style={{
                  marginLeft: Platform.OS == "web" ? 90 : 30,
                  marginRight: 5,
                }}
              />
              <Text
                style={{
                  fontFamily: "quicksand-bold",
                  color: "#6e4732",
                  marginRight: 10,
                }}
              >
                {
                  reviews.filter(
                    (review) =>
                      review.reviewer.uId == item.data.getUsers.uId &&
                      review.favorite
                  ).length
                }
              </Text>
            </View>
          </View>
        )}
      />
      <View
        style={
          Platform.OS != "web"
            ? {
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#c7b2a3",
                borderRadius: 5,
                paddingVertical: "5%",
              }
            : {
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#c7b2a3",
                paddingVertical: 10,
              }
        }
      >
        <Pressable
          style={styles.bottom}
          onPress={() => {
            Alert.alert(
              "Leave Community",
              "are you sure you would like to leave " +
                communityInfo.currCom.cName +
                "?",
              [
                { text: "No" },
                {
                  text: "Yes",
                  onPress: async () => {
                    const userComs = communityInfo.currCom.users.items;
                    const deletedUserCom = userComs.filter(
                      (userCom) =>
                        userCom.usersCommunitiesUId == user.data.getUsers.uId
                    );
                    await leaveCommunity(deletedUserCom[0]);
                    await deleteCom();
                    Alert.alert("please refresh this page to see changes");
                  },
                },
              ]
            );
          }}
        >
          <Text style={styles.buttonText}>
            {"leave " + communityInfo.currCom.cName}
          </Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  statStyle: {
    flexDirection: "row",
    backgroundColor: "#A48578",
    justifyContent: "flex-end",
    marginHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 10,
    marginVertical: 5,
  },
  input: {
    ...globalStyles.input,
    borderColor: "#A48578",
    fontSize: 20,
    backgroundColor: "#E2CFC2",
    color: "#56494C",
    padding: 15,
  },
  nameInput: {
    ...globalStyles.input,
    fontSize: 20,
    color: "#E2CFC2",
    fontFamily: "quicksand-bold",
  },
  topBar: {
    flex: 1,
    marginTop: -30,
    backgroundColor: "#56494C",
    borderRadius: 30,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    flexDirection: "row",
  },
  userTitleText: {
    fontFamily: "quicksand-bold",
    fontSize: 25,
    color: "#6e4732",
    marginLeft: 10,
    marginTop: 10,
  },
  titleText: {
    ...globalStyles.titleText,
    color: "#E2CFC2",
    marginTop: 0,
  },
  text: {
    fontFamily: "quicksand-bold",
    color: "#9DAFD2",
    fontSize: 20,
    marginTop: 5,
  },
  usernames: {
    color: "#6e4732",
    marginHorizontal: 10,
    fontFamily: "quicksand-bold",
    fontSize: 20,
    letterSpacing: 1,
    fontWeight: "100",
  },
  bottom: {
    justifyContent: "center",
    height: 40,
    borderWidth: 2,
    borderColor: "#A48578",
    borderRadius: 20,
    marginHorizontal: 7,
  },

  buttonText: {
    color: "#6e4732",
    fontSize: 20,
    fontFamily: "quicksand-normal",
    paddingHorizontal: 12,
  },
  submitButton: {
    justifyContent: "center",
    height: 40,
    // width: 100,
    alignItems: "center",
    borderWidth: 2,
    borderColor: "#A48578",
    borderRadius: 20,
    margin: 20,
  },
  bar: {
    borderRadius: 10,
    backgroundColor: "#d1beb2",
    paddingVertical: 10,
    borderBottomColor: "black",
    marginVertical: 2,
    marginHorizontal: 10,
    shadowOffset: { width: 1, height: 1 },
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  pencil: {
    marginLeft: 10,
    marginTop: 5,
  },
});
